import {connect} from "react-redux";
import CompleteUCDLeadActivity from "./Complete";
import {bindActionCreators} from "redux";
import {
    markAttendancesDealerLead,
    getActivityDealerLead,
    userCheckoutDealerLead,
    activityTypes,
    newActivityDealerLead,
    addTaggedAlong,
} from "../../../../../../service/Dealer/action";
import {getLeadById, getActivityById} from "../../../../../../service/Lead/action";
import {documentUploadUrlPublic} from "../../../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    markAttendanceDetails: state.Dealer.markAttendance,
    getActivityDetails: state.Dealer.getActivity,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    activityTypesDetails: state.Dealer.activityTypesDetails,
    NewActivityDetails: state.Dealer.saveNewActivity,
    dealerByIdDetails: state.Dealer.dealerById,
    senior: state.Dealer.senior,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    leadById:state.Lead.leadById,
    leadActivityById:state.Lead.leadActivityById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            markAttendancesDealerLead,
            getActivityDealerLead,
            newActivityDealerLead,
            userCheckoutDealerLead,
            activityTypes,
            addTaggedAlong,
            getLeadById,
            getActivityById,
            documentUploadUrlPublic
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteUCDLeadActivity);
